module.exports = global["CvrmVisitorsInformation"] = require("-!/var/www/cvrm/node_modules/babel-loader/lib/index.js!./visitors-information.js");